import { defineStore } from "pinia";
import { ref } from "vue";

export const useServicesStore = defineStore("services", () => {
  const services = ref([]);

  async function fetchServices () {
    const data: any = await $fetch(`${useRuntimeConfig().public.api_host}api/services`);
    return services.value = data;
  }

  return { services, fetchServices };
});
